import React from "react";
import { observer } from "mobx-react";

import { useStores } from "../../../context/StoreContext";

export interface IBillingUsageLabelProps {
    organizationId: string;
}

export const BillingUsageLabel = observer(function BillingUsageLabel(
    props: IBillingUsageLabelProps,
) {
    const { organizationId } = props;

    const { usageMetricsStore } = useStores();

    const usage = usageMetricsStore.getUsageCosts(organizationId);
    if (usage === undefined || usage === false) {
        return null;
    }

    const usageLabel =
        usage.length > 0
            ? usage[0].costItems.find(costItem => costItem.type === "plan")
                  ?.name
            : false;

    return usageLabel ? <>{usageLabel}</> : null;
});
